
  <section class="uk-section" appResponsiveCheck #resize="appResponsiveCheck">
    <div class="uk-container">
        <div class="uk-child-width-1-3@s" uk-grid>
            <div class="uk-flex uk-flex-center uk-text-center">
                <div *ngIf="resize.responsiveCheck; else callInfoTell">
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative" >
                        <img class="uk-position-center" src="assets/images/icon-tel.svg" width="86"/>
                    </div>
                    <p class="uk-text-lead">0 2633 6040</p>
                </div>
                <ng-template #callInfoTell>
                    <a href="tel:026336040">
                        <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative" >
                            <img class="uk-position-center" src="assets/images/icon-tel.svg" width="86" />
                        </div>
                        <p class="uk-text-lead">0 2633 6040</p>
                    </a>
                </ng-template>
            </div>
            <div class="uk-flex uk-flex-center uk-text-center">
                <a href="https://bit.ly/Nissan_Insure" target="_blank">
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative">
                        <img class="uk-position-center" src="assets/images/icon-line-green.svg" width="86"/>
                    </div>
                    <p class="uk-text-lead">&#64;nissan_insure</p>
                </a>
            </div>
            <div class="uk-flex uk-flex-center uk-text-center">
                <a href="https://www.nissanleasing.co.th/th" target="_blank">
                <!-- <a> -->
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative">
                        <img class="uk-position-center" src="assets/images/Icon_Nissan/Nissan_Icon.png" width="86"/>
                    </div>
                    <p class="uk-text-lead">Nissan Leasing</p>
                </a>
            </div>
        </div>
    </div>
  </section>